
/* injects from baggage-loader */

'use strict';

export default class PrivacyPolicyController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/legal/privacy-policy/privacy-policy.controller.js